import React from "react";
import PropTypes from "prop-types";

function ContextChoice({ onSelect, disabled, error }) {
  return (
    <div className="quiz-text">
      {error && (
        <div role="alert" className="alert alert-danger">
          {error}
        </div>
      )}
      <h2><strong>Wybierz konto</strong></h2>
      <div className="row">
        <div className="col-md-3 mb-2">
          <button
            type="button"
            className="btn manage-button manage-red-button btn-block"
            disabled={disabled}
            onClick={() => onSelect("CLIENT")}
          >
            Konto klienta
          </button>
        </div>
        <div className="col-md-3 mb-2">
          <button
            type="button"
            className="btn manage-button manage-teal-button btn-block"
            disabled={disabled}
            onClick={() => onSelect("TEACHER")}
          >
            Konto nauczyciela
          </button>
        </div>
      </div>
    </div>
  );
}

ContextChoice.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

ContextChoice.defaultProps = {
  disabled: false,
  error: "",
};

export default ContextChoice;
